import React from 'react';
import * as FiIcons from 'react-icons/fi';
import { FiAlertTriangle } from 'react-icons/fi';

const SafeIcon = ({ icon, name, ...props }) => {
  let IconComponent;
  try {
    // Check if the icon prop was passed as a string (e.g. icon="Moon")
    if (typeof icon === 'string') {
      IconComponent = FiIcons[`Fi${icon}`];
    } else {
      // Fallback to direct component or name prop
      IconComponent = icon || (name && FiIcons[`Fi${name}`]);
    }
  } catch (e) {
    IconComponent = null;
  }
  
  return IconComponent ? React.createElement(IconComponent, props) : <FiAlertTriangle {...props} />;
};

export default SafeIcon;